export default __webpack_public_path__ + "static/media/mesadetrabajo.1e6ea682.png";